module.exports = __webpack_public_path__ + "img/04_no.e2a23b54.svg";